module.exports = __webpack_public_path__ + "static/img/service_safeguard_icon_3.f810f8d3.svg";